import {
  grayscale70,
  grayscale7002,
  primaryBlueDefault,
  primaryBlueDefault04,
  grayscale40,
  grayscale4004,
  grayscale60,
  grayscale6002,
  primaryBlueDefault02
} from "../assets/styles/vars";

export const getGraduateYearColorInCompany = (
  latestYear: number,
  targetYear: number
) => {
  const yearDiff = latestYear - targetYear;
  switch (yearDiff) {
    case 2:
      return {
        type: "twoYearsAgo",
        color: grayscale40,
        paleColor: grayscale4004
      };
    case 1:
      return {
        type: "oneYearAgo",
        color: grayscale70,
        paleColor: grayscale7002
      };
    case 0:
      return {
        type: "latestYear",
        color: primaryBlueDefault,
        paleColor: primaryBlueDefault04
      };
    default:
      return {
        type: "",
        color: "",
        paleColor: ""
      };
  }
};

export const compareCompanyColors = [
  {
    color: primaryBlueDefault,
    paleColor: primaryBlueDefault02
  },
  {
    color: grayscale60,
    paleColor: grayscale6002
  }
];
